import getMomentDateObj from "./getMomentDateObj"
import setMomentDateObjZero from "./setMomentDateObjZero"
import sortPerformancesByDate from "./sortPerformancesByDate"

const getFirstCurrentPerformance = (today, performances, timezone) => {
    const performancesSortedByDate = sortPerformancesByDate(performances)

    return performancesSortedByDate.find(performance => today.isSameOrBefore(setMomentDateObjZero(getMomentDateObj(performance.timeUtc, timezone))))
}

export default getFirstCurrentPerformance